// authBridge.js
let logoutHandler = null;
export function setLogoutHandler(fn) { logoutHandler = fn; }
export function triggerLogout() { logoutHandler?.(); }
